import { Navigate } from "react-router-dom";
import React, {useContext} from "react";
import { AuthContext } from "../context/authContext.js";
import LoadingPage from "../Error/LoadingPage/LoadingPage.jsx";

export default function OutOfServiceProtect({ children, allowedRoles }) {
  const { user , loading} = useContext(AuthContext);
    if (loading) {
    return <LoadingPage/>; // or spinner component
  }

  console.log(user)
  if (!user) {
    return <Navigate to="/OutOfService" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/OutOfService" replace />;
  }

  return children;
}